import { render } from "./ClientsView.vue?vue&type=template&id=6c460c26"
import script from "./ClientsView.vue?vue&type=script&lang=js"
export * from "./ClientsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__